var _rect, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    rx: 10.56,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8409 55.7954L33.894 46.3375C34.3861 45.5685 35.454 45.4319 36.1239 46.0522L40.0733 49.709C40.6751 50.2662 41.617 50.2211 42.1628 49.6089L49.0271 41.9085C49.673 41.1839 50.8321 41.2761 51.3553 42.0936L60.1245 55.7954C60.7487 56.7708 60.0482 58.0508 58.8902 58.0508H29.0752C27.9171 58.0508 27.2166 56.7708 27.8409 55.7954Z",
    stroke: "black",
    strokeWidth: 1.32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.7199,
    cy: 35.1998,
    r: 4.62,
    stroke: "black",
    strokeWidth: 1.32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageType);
export default __webpack_public_path__ + "static/media/ImageType.901271464933b3e320c9a4e134553567.svg";
export { ForwardRef as ReactComponent };